import * as React from 'react'
import { FaIcon } from '@/lib/fa'
import { getActivityIcon } from '../../../../helpers/ActivityIconResolver'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { formatDateTime } from '@/app/common/dateHelper'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import ViolationsListRowItem from './ViolationsListRowItem'
import { getViolationName } from '@/app/services/violation/violationNameResolver'
import { ViolationModel } from '@/app/models'

const ViolationsListRow = ({
  violation,
  index,
}: {
  violation: ViolationModel
  index: number
}) => {
  const { t } = useLocalize()

  return (
    <tr
      className={`notches-border--right tw-w-fit tw-cursor-pointer tw-border-b tw-bg-white hover:tw-bg-primary/10`}
    >
      <ViolationsListRowItem size="small" bolder={false}>
        {index + 1}
      </ViolationsListRowItem>
      <ViolationsListRowItem
        size="small"
        bolder={false}
        icon={
          <FaIcon
            icon={getActivityIcon(violation?.type) as IconProp}
            className="tw-h-3 tw-w-3 tw-text-content-base"
          />
        }
      >
        {violation?.weight ?? '-'}
      </ViolationsListRowItem>

      <ViolationsListRowItem size="small" bolder={false}>
        {t(getViolationName(violation?.type))}
      </ViolationsListRowItem>
      <ViolationsListRowItem size="small" bolder={false}>
        {formatDateTime(violation?.startTime)}
      </ViolationsListRowItem>
      <ViolationsListRowItem size="small" bolder={false}>
        {formatDateTime(violation?.endTime)}
      </ViolationsListRowItem>
      <ViolationsListRowItem size="small" bolder={false}>
        {violation?.duration ?? '-'}
      </ViolationsListRowItem>
      <ViolationsListRowItem bolder={false} size="small">
        {violation?.chargeSymbol ?? '-'}
      </ViolationsListRowItem>
      <ViolationsListRowItem bolder={false} size="small">
        {violation?.driverCharge ?? '-'}
      </ViolationsListRowItem>
      <ViolationsListRowItem bolder={false} size="small">
        {violation?.companyCharge ?? '-'}
      </ViolationsListRowItem>
    </tr>
  )
}

export default ViolationsListRow
